import { TaxLinesBus } from './TaxLinesBus';
import { BaseBus } from './BaseBus';
import { CommonFunctions } from '../static/common-functions';
import { CommonValues } from '../static/CommonValues';

export class CycleCountHistoryBus extends BaseBus  {
    constructor(data: CycleCountHistoryBus = null) {
        super(data);
        if (data) {
            if (data.lastDate) this.lastDate = new Date(data.lastDate);
            if (data.noteDate) this.noteDate = new Date(data.noteDate);
            if (data.completedDate) this.completedDate = new Date(data.completedDate);
            if (data.startDate) this.startDate = new Date(data.startDate);
        }
}
    CID() {
        return this.cycleCountInvLocXrefId;
    }

    cycleCountInvLocXrefId: any;
    inventoryLocationName: string;
    inventoryId: any;
    companyBranchId: any;
    companyId: any;
    inventoryLocationId: any;
    quantityStarted: number;
    quantityCounted: number;
    currentCost: number;
    avgCost: number;
    ratio: number;

    isActive: boolean;
    nonPart: boolean;

    fullDescription: string;
    inventoryDesc: string;
    number: string;

    vehicleId: any;
    personId: any;
    vehicleName: string;
    vehiclePersonName: string;
    branchName: string;
    regionName: string;
    regionId: any;
    completedDate: Date;
    startDate: Date;
    className: string;
    note: string;
    noteDate: Date;
    notePerson: string;
    createdByPersonId: any;
    createdByName: string;
    lastDate: Date;
    quantityDiff: number;
    costDiff: number;
    commitPerson: string;
    partClassName: string;

}
